import { supabaseClient } from "@/lib/supabase";
import { z } from "@/utils/form";

const PublicSmartAuthZ = z.object({
    auth_method: z.enum(["login", "confirm-account", "signup"]),
    email: z.string().nullable().optional(),
    phone: z.string().nullable().optional(),
    invited_by_name: z.string().nullable().optional(),
    /** False when profile matches by phone but `auth.users.phone` does not (SMS OTP would 422). */
    phone_otp_ready: z.boolean().optional(),
});

export type PublicSmartAuthResult = z.infer<typeof PublicSmartAuthZ>;

export type PublicSmartAuthInput = { email?: string; phone?: string };

export const invokePublicSmartAuth = async (input: PublicSmartAuthInput): Promise<PublicSmartAuthResult> => {
    const body: Record<string, string> = {};
    if (input.email?.trim()) body.email = input.email.trim();
    if (input.phone?.trim()) body.phone = input.phone.trim();

    const { data, error } = await supabaseClient.functions.invoke("public-smart-auth", {
        body,
    });
    if (error) throw error;

    const parsed = PublicSmartAuthZ.safeParse(data);
    if (!parsed.success) {
        throw new Error("Unexpected response from server");
    }
    return parsed.data;
};
